/**
 * Created by 2017/11/07
 */
import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

declare var $: any;

@Injectable()
export class UploadEvsService {
  private header: Headers;
  responseData: any;
  handleError: any;

  constructor(private http: Http, private router: Router) {
    let contentHeaders = new Headers();
    this.header = contentHeaders;
    // this.header.set('Content-Type', 'application/json');
    // if (localStorage.getItem('Access-Token')) {
    //   this.header.set('authorization', localStorage.getItem('Access-Token'));
    // }
  }

  upload(file: File, responseType?: string, postData?: any) {
    if (responseType == '' || responseType == undefined || responseType == null) {
      responseType = 'json';
    }
    let url = environment.api_evs + '/qr_aps/g_store/upload-excel';
    return this.postWithFile(url, file, postData);
  }

  uploadFileAgency(file: File, responseType?: string, postData?: any) {
    if (responseType == '' || responseType == undefined || responseType == null) {
      responseType = 'json';
    }
    let url = environment.qrcode_url + '/agencies/import';
    return this.postWithFile(url, file, postData);
  }

  uploadFileProduct(file: File, responseType?: string, postData?: any) {
    if (responseType == '' || responseType == undefined || responseType == null) {
      responseType = 'json';
    }
    let url = environment.api_evs + '/qr-core-aps' + '/products/import';
    return this.postWithFile(url, file, postData);

  }

  uploadFileUpdateProduct(file: File, responseType?: string, postData?: any) {
    if (responseType == '' || responseType == undefined || responseType == null) {
      responseType = 'json';
    }
    let url = environment.api_evs + '/qr-core-aps' + '/products/import-update';
    return this.postWithFile(url, file, postData);
  }

  uploadFileActiveGuarantee(file: File, responseType?: string, postData?: any) {
    if (responseType == '' || responseType == undefined || responseType == null) {
      responseType = 'json';
    }
    const url = environment.api_evs + '/qr_aps' + '/guarantee/active_by_import';
    return this.postWithFile(url, file, postData);
  }

  uploadCodeViaExcel(file: File, order_id?: any, responseType?: string, postData?: any) {
    if (responseType == '' || responseType == undefined || responseType == null) {
      responseType = 'json';
    }
    let url = environment.api_evs + '/items_order/' + order_id + '/import';
    return this.postWithFile(url, file, postData);
  }

  public postWithFile(url: string, file: File, postData?: any) {
    const token = localStorage.getItem('Access-Token');
    if (token) {
      this.header.set('authorization', token);
    }
    const lang = localStorage.getItem('lang') || 'vi';
    this.header.set('Accept-Language', lang);
    let formData: FormData = new FormData();
    //formData.append('files', files[0], files[0].name);
    // For multiple files
    // for (let i = 0; i < files.length; i++) {
    formData.append('file', file, file.name);// content is key upload file
    //}
    if (postData !== '' && postData !== undefined && postData !== null) {
      for (var property in postData) {
        if (postData.hasOwnProperty(property)) {
          formData.append(property, postData[property]);
        }
      }
    }
    var returnReponse = new Promise((resolve, reject) => {
      this.http.post(url, formData, { headers: this.header }).subscribe(
        res => {
          // console.log('data: ', res.json());
          this.responseData = res.json();
          if (this.responseData.statusCode) {
            if (this.responseData.statusCode == 200 || this.responseData.statusCode == 201) {
              resolve(this.responseData);
            } else if (this.responseData.statusCode == 402) {
              localStorage.removeItem('Access-Token');
              this.router.navigate(['/login']);
              reject(this.responseData);
            } else if (this.responseData.statusCode == 401) {
              localStorage.removeItem('Access-Token');
              this.router.navigate(['/login']);
              reject(this.responseData);
            } else if (this.responseData.statusCode == 404) {
              reject(this.responseData);
            } else if (this.responseData.statusCode == 204) {
              resolve(this.responseData);
            } else {
              reject(this.responseData);
            }
          } else {
            resolve(this.responseData);
          }
        },
        error => {
          //console.log('error: ', error);
          reject(error.json());
        }
      );
    });
    return returnReponse;
  }

  /** Tuanba: 20-3-2024 **/

}



// WEBPACK FOOTER //
// /app/src/app/common/services/UploadEvs.service.ts